<template>
<div v-if="currentBoughtPlans.length > 1" class="opc-zmone__multiple-meeting-select-container">
  <p class="opc-zmone__multiple-meeting-select-container-label">{{ $t('billing.simplify.select_subscription_to_edit') }}</p>
  <zm-select
    size="lg" 
    :model-value="oldPlanCode" 
    @change="handleSwitchOldPlanCode"
    option-text-overflow="wrapping"
    :teleported="true">
    <zm-select-option 
      v-for="plan in currentBoughtPlans" 
      :key="plan.plan_code" 
      :value="plan.plan_code" 
      :label="`${$t(plan.planNameKey)} ${$t(`billing.billing_cycle.${plan.billing_cycle}`)}`"
      :disabled="!plan.allowEdit"
    >
      <p class="zbo-dropdown__item-title mgb-0">
        {{ `${$t(plan.planNameKey)} ${$t(`billing.billing_cycle.${plan.billing_cycle}`)}  (${plan.cartInfo.selected_number} ${$t('plan.unit.user', plan.cartInfo.selected_number)})` }}
      </p>
      <p class="zbo-dropdown__item-desc mgb-0">
        {{ $t('billing.simplify.subscription_id', [plan.referName]) }}
      </p>
    </zm-select-option>
  </zm-select>
  <p class="opc-zmone__multiple-meeting-select-container-desc" v-if="currentEditPlan">
    {{ $t('billing.simplify.subscription_id', [currentEditPlan.referName]) }}
  </p>
</div>
</template>
<script>
import { pageConfig } from '@/common/service/page-config';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'SubscriptionSwitch',
  computed: {
    ...mapGetters(['currentEditPlan', 'oldPlanCode', 'boughtPlans']),
    currentBoughtPlans() {
      if (!this.currentEditPlan) return [];
      return this.boughtPlans.filter(plan => (
        plan.type === this.currentEditPlan.type &&
        plan.category === this.currentEditPlan.category
      ));
    }
  },
  methods: {
    ...mapMutations(['setOldPlanCode']),
    ...mapActions(['switchSelectPlan']),
    handleSwitchOldPlanCode(planCode) {
      const oldPlanCode = this.oldPlanCode;
      this.setOldPlanCode(planCode);
      const nextPlan = this.currentBoughtPlans.find(plan => plan.plan_code === planCode);
      if (!nextPlan) return;
      let defaultLicenses = nextPlan.cartInfo?.selected_number ?? 1;
      const addQty = Number(pageConfig.addQty);
      if (!Number.isNaN(addQty) && addQty > 0) {
        defaultLicenses += addQty;
      }
      this.switchSelectPlan([
        oldPlanCode,
        planCode,
        {
          selected_number: defaultLicenses,
        },
      ]);
      this.$emit('switch-plan', { 
        planCode: planCode,
        billingCycle: nextPlan.billing_cycle,
        licenses: defaultLicenses,
      });
    },
    checkDisableEdit() {
      if (!this.currentEditPlan?.allowEdit) {
        const canEditPlanCode = this.currentBoughtPlans.find(plan => plan.allowEdit)?.plan_code;
        canEditPlanCode && this.handleSwitchOldPlanCode(canEditPlanCode);
      }
    }
  },
  mounted() {
    // switch to allow edit plan if current edit plan is not allow edit
    this.checkDisableEdit();
  }
};
</script>
<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zmone__multiple-meeting-select-container {
  margin-top: 4px;
  &-label {
    font-size: 16px;
    font-weight: 600;
    line-height: 150%;
  }
  &-desc {
    margin-top: 4px;
    color: var(--zoom-color-text-neutral, #686F79);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  }
  .zbo-select {
    max-width: 100%;
  }
  @include media(desktop) {
    .zbo-select {
      min-width: 340px;
    }
  }
}
.zbo-dropdown__item-title {
  color: var(--zoom-color-text-stronger-neutral, #2A2B2D);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: var(--font-font-letterSpacing-14, -0.15px);
}
.zbo-dropdown__item-desc {
  color: var(--zoom-color-text-neutral, #686F79);

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: var(--font-font-letterSpacing-12, 0);
}

.zbo-select-dropdown__item.is-disabled:active {
  .zbo-dropdown__item-desc {
    color: #6e7680;
  }
  .zbo-dropdown__item-title {
    color: #6e7680;
  }
}
</style>
